import dayjs from "dayjs";
import { Flex } from "antd";

import { formatPrice, formatNumber } from "../../../utils/utils";
import Variation from "../../Variation";

import nameDictionary from "../nameDictionary";

export default function renderColumns(locale = "es") {
    return {
        indices: [
            {
                key: "indice",
                title: nameDictionary["indice"][locale],
                dataIndex: "indice",
                render: (text) => <strong>{text}</strong>,
                sorter: (a, b) => a.indice.localeCompare(b.indice),
            },
            {
                key: "descripcion",
                title: nameDictionary["descripcion"][locale],
                dataIndex: "descripcion",
                render: (text) => <strong>{text}</strong>,
                sorter: (a, b) => a.descripcion.localeCompare(b.descripcion),
            },
            {
                key: "variacion",
                title: nameDictionary["variacion"][locale],
                dataIndex: "variacion",
                render: (text) => <Variation value={text} />,
                sorter: (a, b) => a.variacion - b.variacion,
            },
            {
                key: "precioUltimaOperacion",
                title: nameDictionary["precioUltimaOperacion"][locale],
                dataIndex: "precioUltimaOperacion",
                render: (_, record) => formatPrice(record.precioUltimaOperacion, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioUltimaOperacion - b.precioUltimaOperacion,
            },
            {
                key: "precioCierreAnterior",
                title: nameDictionary["precioCierreAnterior"][locale],
                dataIndex: "precioCierreAnterior",
                render: (_, record) => formatPrice(record.precioCierreAnterior, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioCierreAnterior - b.precioCierreAnterior,
            },
            {
                key: "precioMinimo",
                title: nameDictionary["precioMinimo"][locale],
                dataIndex: "precioMinimo",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioMinimo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMinimo - b.precioMinimo,
            },
            {
                key: "precioMaximo",
                title: nameDictionary["precioMaximo"][locale],
                dataIndex: "precioMaximo",
                responsive: ["lg"],
                render: (_, record) => formatPrice(record.precioMaximo, record.moneda || "ARS", locale, "-"),
                sorter: (a, b) => a.precioMaximo - b.precioMaximo,
            },
        ]
    };
}
